<app-header *ngIf="logged"></app-header>
<app-public-header *ngIf="isPagePublic"></app-public-header>


<div class="page">
    <mat-drawer-container opened="false">

        <ngx-spinner name="InitPage" bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-grid-beat" [fullScreen]="true">
            <p *ngIf="getlanguajeSpinner()=='en'" style="font-size: 20px; color: white">Loading...</p>
            <p *ngIf="getlanguajeSpinner()=='es'" style="font-size: 20px; color: white">Cargando...</p>
        </ngx-spinner>

        <ngx-spinner name="loading" bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-grid-beat" [fullScreen]="true">
            <p *ngIf="getlanguajeSpinner()=='en'" style="font-size: 20px; color: white">Loading...</p>
            <p *ngIf="getlanguajeSpinner()=='es'" style="font-size: 20px; color: white">Cargando...</p>
        </ngx-spinner>
        <ngx-spinner name="loadingSecond" bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-grid-beat" [fullScreen]="true">
            <p *ngIf="getlanguajeSpinner()=='en'" style="font-size: 20px; color: white">Loading...</p>
            <p *ngIf="getlanguajeSpinner()=='es'" style="font-size: 20px; color: white">Cargando...</p>
        </ngx-spinner>
        <ngx-spinner name="AccessValidation" bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-grid-beat" [fullScreen]="true">
            <p *ngIf="getlanguajeSpinner()=='en'" style="font-size: 20px; color: white">Loading...</p>
            <p *ngIf="getlanguajeSpinner()=='es'" style="font-size: 20px; color: white">Cargando...</p>
        </ngx-spinner>

        <ngx-spinner name="translate" bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-grid-beat" [fullScreen]="true">
            <p *ngIf="getlanguajeSpinner()=='en'" style="font-size: 20px; color: white">Loading...</p>
            <p *ngIf="getlanguajeSpinner()=='es'" style="font-size: 20px; color: white">Cargando...</p>
        </ngx-spinner>
        <router-outlet *ngIf="logged"></router-outlet>
        
        <app-footer *ngIf="logged"></app-footer>
    </mat-drawer-container>


    
<router-outlet *ngIf="isPagePublic"></router-outlet>
        
<app-public-footer *ngIf="isPagePublic"></app-public-footer>

</div> 